import { render, staticRenderFns } from "./main-review.vue?vue&type=template&id=43d335f3&scoped=true"
import script from "./main-review.vue?vue&type=script&lang=js"
export * from "./main-review.vue?vue&type=script&lang=js"
import style0 from "./main-review.vue?vue&type=style&index=0&id=43d335f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d335f3",
  null
  
)

export default component.exports